import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
    import type { ChangedFields, Employee } from '@/types';
    import EmployeeChangesGroup from '../EmployeeChangesGroup.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AddressTab',
  props: {
    employee: {},
    data: {}
  },
  setup(__props: any) {

    const props = __props;

    const employeeWithAddress = computed(() => {
        return {
            ...props.employee,
            address: props.employee.addresses[0],
        };
    });

    const values = computed(() => {
        return [
            { name: 'address', group: 'address', key: 'address' },
            { name: 'address2', group: 'address', key: 'address' },
            { name: 'postal_code', group: 'address', key: 'address' },
            { name: 'city', group: 'address', key: 'address' },
            { name: 'country_code', group: 'address', key: 'address' },
        ];
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EmployeeChangesGroup, {
    data: _ctx.data,
    values: values.value,
    employee: employeeWithAddress.value
  }, null, 8, ["data", "values", "employee"]))
}
}

})